/** The route of the screen shown when the page's first navigation could not load its chunk. */
export const LOAD_FAILED_PATH = 'load-failed'

/** Where the router goes after a lazy route's chunk failed to load. */
export interface StaleChunkFallback {
  url: string
  /** Leave the address bar alone, so it keeps the link the visitor opened. */
  skipLocationChange: boolean
}

/**
 * A tab with a page on screen stays on that page while the reload replaces it.
 *
 * The page's first navigation has no page to stay on. `router.url` is still `/` then, and the guard on `/` sends a
 * signed-out visitor to sign-in, so a public link opened after a deploy ended on the sign-in page. It goes to the
 * load-failed screen instead, without touching the address bar: the reload, or the visitor's own refresh, then opens
 * the link they came for (docs/web-releases.md).
 */
export function staleChunkFallback(navigated: boolean, currentUrl: string): StaleChunkFallback {
  return navigated
    ? { url: currentUrl, skipLocationChange: false }
    : { url: `/${LOAD_FAILED_PATH}`, skipLocationChange: true }
}
